export const purchaseActionId = 'hySzCPCenJ8YEJ-o4qID';
